<ng-template #loading_influencers>
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
</ng-template>



<compass-influencers-form *ngIf="influencers$ | async as influencers; else loading_influencers" [setup]="influencers"
    style="width: 100%;"></compass-influencers-form>

<compass-influencers-accordion></compass-influencers-accordion>